import {getCurrentInstance,} from "vue"
import {getActiveHead as _getActiveHead,} from "unhead"

export function getActiveHead () {
    const {proxy,} = getCurrentInstance()

    return proxy.$head || _getActiveHead()
}
